<template>
  <div class="signup">

    <a-form
      :form="form"
      @submit="handleSubmit"
      >

      <a-form-item
        label="E-mail"
      >
        <a-input
          v-decorator="[
            'signup_email',
            {
              rules: [{
                type: 'email', message: 'The input is not valid E-mail!',
              }, {
                required: true, message: 'Please enter your email address.',
              }]
            }
          ]"
        />
      </a-form-item>

      <a-form-item
        label="Password"
      >
        <a-input
          v-decorator="[
            'signup_password',
            {
              rules: [{
                required: true, message: 'Please enter a password!',
              }],
            }
          ]"
          type="password"
        />
      </a-form-item>

      <a-form-item style="float: left;">
        <a-checkbox
          v-decorator="['agreement', {valuePropName: 'checked'}]"
          @change="onAgreementChange"
        >
          I accept the <a href="/terms" target="_blank">
            terms of service
          </a> and <a href="/privacy" target="_blank">privacy policy</a>.
        </a-checkbox>
      </a-form-item>

      <a-form-item style="float: right;">
        <a-button
          type="primary"
          html-type="submit"
          :disabled="!agreement"
        >
          Register
        </a-button>
      </a-form-item>

      <a-form-item v-if="feedback">
        <span class="feedback">
          {{ feedback }}
        </span>
      </a-form-item>
    </a-form>

  </div>
</template>

<script>
// eslint-disable-next-line
import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  name: "SignUp",
  data() {
    return {
      form: this.$form.createForm(this),
      feedback: null,
      agreement: false,
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault();
      this.feedback = null;
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
          firebase.auth().createUserWithEmailAndPassword(
            values.signup_email, values.signup_password)
            .then(cred => {
              console.log("!", cred.user.uid);
              this.$router.push("/app");
            })
            .catch(err => {
              this.feedback = err.message;
            })
        }
      });
    },

    onAgreementChange(e) {
      this.agreement = e.target.checked;
    },
    openNotification(e) {
      e.preventDefault();
      this.$notification.open({
        message: 'Coming soon',
        description:
          'More info will be added soon.',
      });
    },
  }
}
</script>

<style scoped>

.feedback {
  font-weight: bold;
  color: #faad14;
}

</style>

